import { render, staticRenderFns } from "./PaymentsOverview.vue?vue&type=template&id=9ee407b0&"
import script from "./PaymentsOverview.vue?vue&type=script&lang=js&"
export * from "./PaymentsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports